import CheckmarkIcon from '@clearkit/icons/glyphs/CheckmarkOrb';
import ClockIcon from '@clearkit/icons/glyphs/Clock';
import PauseIcon from '@clearkit/icons/glyphs/Pause';
import SyncIcon from '@clearkit/icons/glyphs/Sync';
import WarningIcon from '@clearkit/icons/glyphs/Warning';

import { audienceStatuses } from '~/lib/audiences';

const icons = {
  [audienceStatuses.active]: CheckmarkIcon,
  [audienceStatuses.error]: WarningIcon,
  [audienceStatuses.initializing]: ClockIcon,
  [audienceStatuses.inProgress]: SyncIcon,
  [audienceStatuses.inactive]: PauseIcon,
};

const styles = {
  [audienceStatuses.active]: 'fill-gradient-br-green',
  [audienceStatuses.error]: 'fill-gradient-br-yellow',
  [audienceStatuses.inProgress]: 'fill-gradient-br-blue',
  [audienceStatuses.initializing]: 'text-gray-400',
  [audienceStatuses.inactive]: 'text-gray-400',
};

export default function AudiencesStatusIcon({ audience, className, size }) {
  const Icon = icons[audience.status];
  const iconClass = styles[audience.status];

  if (!Icon) {
    return null;
  }

  return (
    <Icon
      className={classnames(className, iconClass)}
      style={{ height: size, width: size }}
    />
  );
}

AudiencesStatusIcon.propTypes = {
  audience: PropTypes.object.isRequired,
  className: PropTypes.string,
  size: PropTypes.number,
};
